export default __webpack_public_path__ + "static/Bugsnag-8f3cef7ac8761245524251464a506be8.png";